import React, { useRef } from "react";
// import { CXContext } from "./cxContext";
import * as dc from "dc";
import * as d3 from 'd3';
import {Grid,Row,Col} from 'react-flexbox-grid';
import { rhythm } from "../utils/typography.js";
import { css } from "glamor";

import { StudentGrades } from "./row_student_grades";
import { StudentGrades1 }  from "./row_student_grades_by_month";

export const StudentGradesGroup = props => {

  const style  = css({
    width:'100%',
    height:'auto',
    boxSizing:'border-box',
    //marginRight: rhythm(2),
    paddingTop: rhythm(0),
    paddingRight: rhythm(.01),
    paddingBottom: rhythm(.3),
    paddingLeft: rhythm(1),
    '& label':{
      textTransform:'capitalize',
    }
  })

  const months = [0,1,2,3,4,5,6,7,8,9,10,11];

  const commasFormatter = (num) => {
    return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)//d3.format(",.0f");
  }

  return (
      <Row>
        <Col md={2}  >
          <StudentGrades title="Student Grades" type="rowchart" className="rowchart" metric={props.metric}
             showMetricsSelector={false} reset={props.reset}  style={style}/>
        </Col >
        <Col md={10}  >
          <Row >
            {months.map((tag,i) => {
              return (
                <Col md={1}  >
                  <StudentGrades1 key={i} index={i} style={style} metric={props.metric} reset={props.reset}/>
                </Col >
              )
            })}
          </Row>
        </Col >
      </Row>
  );
};
